var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentBlank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2167ae",
    d: "M18 5a1 1 0 0 0-1-1h-6.14a1 1 0 0 0-.36.07V7.5C10.5 8.33 9.83 9 9 9H6v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1zm-8.5-.03L6.6 8H9a.5.5 0 0 0 .5-.5zM5 9.04c0-.52.2-1.01.55-1.38l3.86-4.04A2 2 0 0 1 10.86 3H17a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentBlank);
export default __webpack_public_path__ + "static/media/DocumentBlank.436381de468160771592f8008f5cebe3.svg";
export { ForwardRef as ReactComponent };